module.exports = function(service) {
	'use strict'
	service.factory('elasticSearch', elasticSearch);
	elasticSearch.$inject = ['cleanArray','config'];
	function elasticSearch(cleanArray,config) {
		return {
			'getUrl': function(searchData) {
				// skidanje celih reci koje u sebi sadrze specijalne karaktere
				searchData = searchData.replace(/\b[a-zA-Z0-9ćĆčČđĐšŠžŽ]*[^a-zA-Z0-9ćĆčČđĐšŠžŽ\s]+[a-zA-Z0-9ćĆčČđĐšŠžŽ]*\b/g, '');
				
				// skidanje svih specijalnih karaktera za elastic search
				searchData = searchData.replace(/[^a-zA-Z0-9ćĆčČđĐšŠžŽ\s]/g, '')
				
				// trim removes whitespace from both ends of this string
				searchData = searchData.trim()

				// splits the string by one or more whitespace characters into an array of words.
				var words = searchData.split(/\s+/);
				
	          	cleanArray.clean(words);
	          	var postSearch = '';
	          	for(var i=0;i<words.length;i++) {
		            if(i==0) { 
		              if(!isNaN(words[i])) {
		                if(words[i].length>=5) {
		                  postSearch = 'id:'+ words[i]+'*';
		                } else {
		                //   if(parseInt(words[i])>moment().date()) {
		                //     var month = moment().month();
		                //   } else {
		                //     var month = moment().month()+1;
		                //   }
		                //   if(month<=9) {
		                //     month='0'+month;
		                //   }
		                //   var year = moment().year();
		                //   postSearch = 'post_date:'+ words[0]+ '.'+month+'.'+year;
							if(words[i].indexOf("*")==-1) {
								words[i] += '*';
							}
							postSearch = postSearch.concat('post_title:' + words[i]);
							}
		              }else {
		                  if(words[i].indexOf("*")==-1) {
		                    words[i] += '*';
		                  }
		                postSearch = postSearch.concat('post_title:' + words[i]);
		              }
		            } else {
		              if(words[i].indexOf("*")==-1) {
		                words[i] += '*';
		              }
		              postSearch = postSearch.concat('%20AND%20post_title:' + words[i]);
		            }
	        	}
          		var url = config.baseElasticSearchHref+'_search?q='+ postSearch+ '&sort=uts:desc';
				return url
			}
		}
	   	 
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/elasticSearchService.js
// module id = 600
// module chunks = 0